import React from 'react';
import { useTranslation } from 'react-i18next';

import type IImpactedCustomersSection from './interfaces/IImpactedCustomersSection';

import styles from './sass/ImpactedCustomersSection.module.scss';

const formatNumber = (value: number): string => value?.toLocaleString('en-US') ?? '0';

function ImpactedCustomersSection({
  customersPercentage,
  impactedCustomersCount,
  totalCustomersCount,
}: IImpactedCustomersSection): React.JSX.Element {
  const { t } = useTranslation();
  const normalizedCustomersPercentage = Math.min(customersPercentage, 100);

  return (
    <section className={styles.tile}>
      <h4 className={styles.tileTitle}>{t('valueChainMap.resultCardImpactedCustomers')}</h4>
      <div className={styles.progressRow}>
        <div className={styles.progressBars}>
          <div
            className={styles.progressFill}
            style={{ flex: `${normalizedCustomersPercentage} 0 0` }}
          />
          <div
            className={styles.progressRemainder}
            style={{ flex: `${100 - normalizedCustomersPercentage} 0 0` }}
          />
        </div>
        <span className={styles.progressLabel}>
          {customersPercentage}
          %
        </span>
      </div>
      <p className={styles.descMeta}>
        <span className={styles.metaAccent}>{formatNumber(impactedCustomersCount)}</span>
        {' '}
        {t('valueChainMap.resultCardOf')}
        {' '}
        {formatNumber(totalCustomersCount)}
        {' '}
        {t('valueChainMap.resultCardCustomers')}
      </p>
    </section>
  );
}

export default ImpactedCustomersSection;
